// Copyright (c) Docugami, Inc. All rights reserved.
import { ComparisonUnit } from "./ComparisonUnit";
import { ComparisonUnitAtom } from "./ComparisonUnitAtom";
import { StringBuilder } from 'utils/StringBuilder';

export class ComparisonUnitToken extends ComparisonUnit
{
    public tokenString: string = "";
    public correspondingToken: ComparisonUnitToken | null = null;
    public rangeTokenIdx: number = -1; // this is used when inserting content controls - need to keep the Word range with the token.

    constructor(contents: ComparisonUnit[] | string)
    {
        super();
        if (typeof contents === 'string') {
            this.tokenString = contents;
        }
        else if (typeof contents === 'object') {
            this.contents = contents;
        }
        else {
            throw new Error("invalid argument error");
        }
    }

    toString(indent: number, includeAtoms: boolean = true): string
    {
        const indentString = ' '.repeat(indent);
        const sb = new StringBuilder();
        sb.appendLine(indentString + `ComparisonUnitToken: >${this.tokenString}<`);
        if (includeAtoms) {
            this.contents.forEach(comparisonUnit =>
            {
                const comparisonUnitAtom = comparisonUnit as ComparisonUnitAtom;
                sb.appendLine(indentString + comparisonUnitAtom.toString());
            })
        }
        return sb.toString();
    }
}

